import React from 'react';
import cn from 'classnames';
import { isNumber } from 'lodash';

import './sportFilterHeading.scss';

interface Props {
    title: string;
    logo: React.ReactNode;
    isActive: boolean;
    count?: number;
    onClick?: () => void;
}

const SportFilterHeading: React.FC<Props> = ({
    isActive,
    onClick,
    title,
    logo,
    count,
}) => {
    return (
        <div
            styleName={cn('container', { 'is-active': isActive })}
            onClick={onClick}
        >
            {logo}
            <div styleName="ellipsis">{title}</div>
            {isNumber(count) && <div styleName="counter">{count}</div>}
        </div>
    );
};

export default React.memo(SportFilterHeading);
